import React, { useState } from "react";
import PasswordInput from "../utils/PasswordInput";

function EmailValidation({ onValidateSucess }) {
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [exists, setExists] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
  };

  const apiUrl = process.env.REACT_APP_API;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        apiUrl + "api/usuario-editora/validate-usuario-editora",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setExists(data.exists);
      if (data.exists === false) {
        onValidateSucess(email, password);
      }
    } catch (error) {
      console.error("Error validating email:", error);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <h2>Criar Conta</h2>
        {exists !== null && (
          <p>
            {!exists ? (
              "Email é válido e disponível"
            ) : (
              <p style={{ color: "red" }}>
                {"Já existe um conta com esse Email!"}
              </p>
            )}
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <label>
            Email:
            <input
              type="email"
              value={email}
              onChange={handleChange}
              required
            />
          </label>
          <label for="">
            <PasswordInput value={password} onChange={handlePasswordChange} />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? "Validando..." : "Criar conta"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EmailValidation;
